<style>
.checkbox-position-offset {
  margin-top: 35px;
  margin-left: 25px;
  margin-bottom: 10px;
}
</style>

<template>
  <div>
    <div class="custom-control custom-checkbox checkbox-position-offset">
      <input
        class="custom-control-input"
        type="checkbox"
        @change="emitFilter"
        :name="'checkbox-' + id"
        :id="'checkbox-' + id"
      />
      <label class="custom-control-label" :for="'checkbox-' + id">{{
        label
      }}</label>
    </div>
  </div>
</template>

<script lang="babel">
export default {
  props: ['value', 'label', 'id', 'attributes', 'name'],
  computed: {
    realValue() {
      if (!this.value) {
        return false;
      }

      if (typeof this.attributes === 'object') {
        return this.value[this.attributes.column].value;
      } else if (this.attributes) {
        return this.value[this.attributes];
      } else {
        return this.value;
      }
    },
  },
  methods: {
    emitFilter(event) {
      if (event.target.checked) {
        let attributes = {};
        if (typeof this.attributes === 'object') {
          attributes = {
            [this.attributes.column]: { operator: this.attributes.operator, value: this.attributes.value }
          }
        } else if (this.attributes) {
            attributes = {
              [this.attributes]: true,
            }
        }

        let name = this.name ? this.name : 'where'

        this.$emit('filter-change', {
          id: this.id,
          name: name,
          attributes,
          value: this.attributes.value
        });
      } else {
        this.$emit('filter-change', { id: this.id });
      }
    }
  }
};
</script>
